import { AccountCard } from './components/AccountCard'
import { MobileAppCard } from './components/mobile-app/MobileAppCard'
import { WorkspaceCard } from './components/WorkspaceCard'
import type { GeneralPanel } from './settings-nav'

export function GeneralSection({
  panel = 'hub',
  showMobileApp = false
}: {
  panel?: GeneralPanel
  /** `ui.settings.mobile_app` entitlement: the QR pairing card and paired-device list. */
  showMobileApp?: boolean
}) {
  return (
    <div className="flex flex-col gap-4">
      <AccountCard />
      {showMobileApp ? <MobileAppCard focus={panel === 'mobile-app'} /> : null}
      <WorkspaceCard />
    </div>
  )
}
